// Google Ads conversion event helper.
//
// The base tag (AW-18294273499) is installed via public/index.html. This
// module fires the specific `event: conversion` calls when the user
// completes one of our tracked conversion actions (signup, book, checkout).
//
// Each conversion action needs its own LABEL created inside Google Ads:
//     Google Ads → Goals → Conversions → New conversion action → Website
// Paste the resulting label (looks like `AbCd_efGhI-jKl123M`) into the
// map below. Firing without a label will not error — Google silently
// drops the event — so the app stays functional even before labels exist.

const GTAG_ID = 'AW-18294273499';

// TODO(user): create these three conversion actions in Google Ads and
// paste their labels here. Empty strings are treated as "not yet
// configured" and skipped silently.
export const CONVERSION_LABELS = {
  signup: '',
  booking: '',
  checkout: '',
  chat_started: '',  // Fires when a visitor opens the LeadConnector chat
};

/**
 * Fire a Google Ads conversion event.
 * @param {'signup'|'booking'|'checkout'} action  which conversion to record
 * @param {object} [opts]
 * @param {number} [opts.value]           dollar value of the conversion
 * @param {string} [opts.currency='USD']  ISO currency code
 * @param {string} [opts.transactionId]   your internal id (dedupe key)
 */
export function fireConversion(action, opts = {}) {
  const label = CONVERSION_LABELS[action];
  if (!label) return; // Not yet configured in Google Ads — no-op.
  if (typeof window.gtag !== 'function') return; // gtag hasn't loaded
  const params = {
    send_to: `${GTAG_ID}/${label}`,
  };
  if (typeof opts.value === 'number') params.value = opts.value;
  params.currency = opts.currency || 'USD';
  if (opts.transactionId) params.transaction_id = opts.transactionId;
  try {
    window.gtag('event', 'conversion', params);
  } catch {
    /* never let analytics failures affect UX */
  }
}
